export default "__VITE_ASSET__3472e4c3__"